module.exports = "<footer class=\"app-footer\">\r\n  <!-- <span><a href=\"http://coreui.io\"></a> &copy; 2018 creativeLabs.</span> -->\r\n  <span class=\"ml-auto\">Copyright &copy; 2018<a href=\"http://infras.com.vn\"> Infras Consult</a>.  All rights reserved. AMISS version 4.0 - Build {{version}}</span>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/components/app-footer/app-footer.component.html
// module id = ../../../../../src/app/components/app-footer/app-footer.component.html
// module chunks = main